import React, { useState } from "react";
import axios from "axios";
import Header from "../components/Header";
import config from "../config";

const Feedback = () => {
  const [rating, setRating] = useState(0);
  const [hover, setHover] = useState(0);
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState("");
  const [error, setError] = useState("");

  const submitFeedback = async (e) => {
    e.preventDefault();

    console.clear();
    console.log("========== FEEDBACK SUBMIT ==========");

    setSuccess("");
    setError("");

    const token = localStorage.getItem("token");

    console.log("Token :", token);
    console.log("Rating :", rating);
    console.log("Message :", message);
    console.log("API :", `${config.API_BASE_URL}/api/feedback`);

    if (!token) {
      setError("Please login to submit your feedback.");
      return;
    }

    if (rating === 0) {
      setError("Please select your rating.");
      return;
    }

    if (message.trim().length < 20) {
      setError("Please write at least 20 characters.");
      return;
    }

    try {
      setLoading(true);

      console.log("Sending request...");

      const response = await axios.post(
        `${config.API_BASE_URL}/api/feedback`,
        {
          rating,
          message,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response:", response.data);

      if (response.data.success) {
        setSuccess(
          "🙏 Thank you for sharing your experience. Your review has been submitted successfully and will appear after admin approval."
        );

        setRating(0);
        setHover(0);
        setMessage("");
      }
    } catch (err) {
      console.error(err);

      if (err.response) {
        console.log("Status:", err.response.status);
        console.log("Data:", err.response.data);
      }

      setError(
        err.response?.data?.message ||
          "Unable to submit feedback. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />

      <div style={styles.page}>
        <div style={styles.card}>

          <h1 style={styles.heading}>
            Share Your Experience
          </h1>

          <p style={styles.subtitle}>
            We sincerely value your feedback. Please share your experience
            regarding Tuli Ji's astrology consultation, gemstone recommendation,
            gemstone quality, delivery service, and overall experience.
            If Tuli Ji's guidance has brought positive changes or benefited you
            in any way, we'd be grateful if you shared your journey.
          </p>

          {success && (
            <div style={styles.success}>
              {success}
            </div>
          )}

          {error && (
            <div style={styles.error}>
              {error}
            </div>
          )}

          <form onSubmit={submitFeedback}>

            <label style={styles.label}>
              Overall Rating
            </label>

            <div style={styles.starContainer}>
              {[1,2,3,4,5].map((star)=>(
                <span
                  key={star}
                  onClick={()=>setRating(star)}
                  onMouseEnter={()=>setHover(star)}
                  onMouseLeave={()=>setHover(0)}
                  style={{
                    ...styles.star,
                    color: star <= (hover || rating)
                      ? "#ffc107"
                      : "#ddd"
                  }}
                >
                  ★
                </span>
              ))}
            </div>

            <label style={styles.label}>
              Your Experience
            </label>

            <textarea
              rows={7}
              maxLength={500}
              value={message}
              onChange={(e)=>setMessage(e.target.value)}
              placeholder="Please tell us about your experience with Tuli Ji's astrology consultation, gemstone recommendation, gemstone quality, delivery, customer support, and the positive changes you experienced after following the guidance."
              style={styles.textarea}
            />

            <div style={styles.counter}>
              {message.length}/500 Characters
            </div>

            <button
              type="submit"
              disabled={loading}
              style={{
                ...styles.button,
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? "Submitting..." : "Submit Feedback"}
            </button>

          </form>

        </div>
      </div>
    </>
  );
};

export default Feedback;

const styles = {

  page:{
    minHeight:"100vh",
    background:"#f5f7fb",
    padding:"40px 15px"
  },

  card:{
    maxWidth:"850px",
    margin:"auto",
    background:"#fff",
    borderRadius:"15px",
    padding:"35px",
    boxShadow:"0 5px 18px rgba(0,0,0,.08)"
  },

  heading:{
    textAlign:"center",
    fontSize:"32px",
    marginBottom:"10px"
  },

  subtitle:{
    textAlign:"center",
    color:"#666",
    lineHeight:1.7,
    marginBottom:"35px"
  },

  label:{
    display:"block",
    fontWeight:"bold",
    marginBottom:"10px",
    marginTop:"20px"
  },

  starContainer:{
    textAlign:"center",
    marginBottom:"25px"
  },

  star:{
    fontSize:"42px",
    cursor:"pointer",
    margin:"0 4px",
    transition:"0.2s"
  },

  textarea:{
    width:"100%",
    border:"1px solid #ccc",
    borderRadius:"10px",
    padding:"15px",
    resize:"vertical",
    fontSize:"15px",
    outline:"none",
    boxSizing:"border-box"
  },

  counter:{
    textAlign:"right",
    color:"#888",
    marginTop:"8px",
    fontSize:"13px"
  },

  button:{
    width:"100%",
    marginTop:"30px",
    padding:"15px",
    border:"none",
    borderRadius:"10px",
    background:"#ff9800",
    color:"#fff",
    fontSize:"17px",
    fontWeight:"bold",
    cursor:"pointer"
  },

  success:{
    background:"#d4edda",
    color:"#155724",
    padding:"15px",
    borderRadius:"8px",
    marginBottom:"20px"
  },

  error:{
    background:"#f8d7da",
    color:"#721c24",
    padding:"15px",
    borderRadius:"8px",
    marginBottom:"20px"
  }

};